import { createAction, props } from '@ngrx/store';

export const login = createAction(
  '[Auth] User Login',
  props<{ email: string, password: string }>()
);

export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{ token: string, user: any }>()
);

export const loginFailure = createAction(
  '[Auth] Login Failure',
  props<{ error: string }>()
);

export const register = createAction(
  '[Auth] Register',
  props<{ name: string, email: string; linkedin_url: string; country_id: string, company_invoice: boolean, company_name: string, company_identifier: string, company_country_id: string, company_county: string, company_town: string, company_zip_code: string, company_address: string, is_tax_payer: boolean, password: string; password_confirmation: string, search_id: any; event: any}>()
);

export const registerSuccess = createAction(
  '[Auth] Register Success',
  props<{ user: any; }>()
);

export const registerFailure = createAction(
  '[Auth] Register Failure',
  props<{ error: any; }>()
);

export const logout = createAction(
  '[Auth] Logout'
);

export const logoutSuccess = createAction(
  '[Auth] Logout Success'
);

export const logoutFailure = createAction(
  '[Auth] Logout Failure',
  (error: any) => ({error})
);

export const updateUser = createAction(
  '[Auth] Update User',
  props<{ user: any }>()
);

export const setIsLoggedIn = createAction(
  '[Auth] Set Is Logged In',
  (isLoggedIn: boolean) => ({ isLoggedIn })
);

export const updateUserTestCode = createAction(
  '[Auth] Update User Test Code',
  props<{ testCode: string }>()
);

/*
export const updateUserSuccess = createAction(
  '[Auth] Update User Success',
  props<{  user: any }>()
);

export const updateUserFailure = createAction(
  '[Auth] Update User Failure',
  props<{ error: string }>()
);
*/
